import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSend: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSend"><Path d="M14 21.5L20.5 3.5L2.5 10L11 13L14 21.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconSend;
